import { useCallback, useContext, useState } from 'react';
import { Trans, useLingui } from '@lingui/react/macro';
import { Modal } from 'antd';
import { userContext } from 'contexts/UserContext';
import { User } from 'types';

const MESSAGE_READ = 'service_notification';

export function ServiceNotificationModal() {
  const { t } = useLingui();
  const { user } = useContext(userContext) as { user: User | null };
  const [isVisible, setState] = useState(() => {
    try {
      const value = localStorage.getItem(MESSAGE_READ);
      if (value || !user) return false;
      if (user.Groups.some(({ Country }) => Country === 'ru')) return true;
      return false;
    } catch {
      return false;
    }
  });

  const hide = useCallback(() => {
    localStorage.setItem(MESSAGE_READ, 'true');
    setState(false);
  }, []);

  if (!user) return null;

  return (
    (<Modal
      open={isVisible}
      okText={t`Понятно`}
      title={t`Доступ к GSM мониторингу предоставляется на платной основе`}
      maskClosable={false}
      closable={false}
      onOk={hide}
      cancelButtonProps={{ hidden: true }}
    >
      <Trans>
        <strong>Что это означает простыми словами?</strong>
        <ol>
          <li>
            Доступ к мониторингу платный и составляет <strong>200 руб</strong>{' '}
            за один аппарат в месяц. Метод расчетов - авансовый. Списание
            средств с баланса будет происходить первого числа ежемесячно в
            размере 200 руб * число аппаратов, зарегистрированных в мониторинге
            на дату списания.
          </li>
        </ol>
        <p>
          В случае, если средств на балансе не хватает на все оборудование,
          доступ к личному кабинету будет приостановлен до пополнения баланса.
          Все описанное выше распространяется на оборудование,
          зарегистрированное в мониторинге до 06.2021.
        </p>
        <ol>
          <li>
            При регистрации нового оборудования на ваш баланс будет начислена
            сумма 200 руб на каждую единицу оборудования
          </li>
          <li>
            Операции связанные с добавлением и удалением оборудования с
            01.06.2022 будут производиться ТОЛЬКО через службу технической
            поддержки.
          </li>
          <li>
            Возможность принимать платежи через приложение и/или через QR код
            так же становится платной. Оплата составляет 100 руб/мес. Данную
            услугу вы можете самостоятельно подключить/отключить в мониторинге.
          </li>
        </ol>

        <p>
          Первое списание денежных средств с баланса произойдёт 01.07.2022. До
          этого момента настоятельно рекомендуем вам пополнить ваш баланс в
          личном кабинете.
        </p>
      </Trans>
    </Modal>)
  );
}
